import Ajax from 'js/utils/ajax/ajax';

export const getChangeableEventTypes = (trackingReference: string) =>
  Ajax.get(`/orders/v2/${trackingReference}/changeableeventtypes`);

export const updateOrderStatus = (orderStatusChange, trackingReference) =>
  Ajax.patch(`/orders/v2/${trackingReference}/statuschange`, orderStatusChange);
